<!-- 用户中心布局页。主要用在用户中心页面 -->
<template>
    <div class="user-layout-container"></div>
</template>

<script>

export default {
    name: 'UserLayout',
    components: {

    },
    data() {
        return {
            

        };
    },
    mounted() {
        
    },
    methods: {
        
    }
}
</script>

<style lang="scss">

</style>